// extracted by mini-css-extract-plugin
export default {"cliHeading":"CliChange_cliHeading__j6iWQ","cliNumber":"CliChange_cliNumber__iQRvT","callerIdDescription":"CliChange_callerIdDescription__Dgeur","random":"CliChange_random__l5PVs"};